import CloseIcon from '@icons/CloseIcon';
import {
	Box,
	Button,
	ButtonProps,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	IconButton,
	Slide,
	styled,
	useMediaQuery,
	useTheme
} from '@mui/material';
import {TransitionProps} from '@mui/material/transitions';
import React, {forwardRef, ReactElement, Ref, useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import {ICompetition} from '../../ICompetitions';
import barandebash from './assets/images/t0/barandebash.webp';
import desc from './assets/images/t0/bdesc.webp';
import bg from './assets/images/t0/bg-new.webp';
import start from './assets/images/t0/bstart.webp';
import line from './assets/images/t0/line.webp';
// import winner from './assets/images/t0/winner.webp';

type IProps = {
	competition: ICompetition;
	referrer: string;
};

const Transition = forwardRef(function Transition(
	props: TransitionProps & {children: ReactElement<any, any>},
	ref: Ref<unknown>
) {
	return <Slide direction="up" ref={ref} {...props} />;
});

const ColorButton = styled(Button)<ButtonProps>(() => ({
	color: 'white',
	backgroundColor: 'rgb(232 190 115)',
	'&:hover': {
		backgroundColor: 'rgb(232 190 115)'
	}
}));

export default function MuharramCompetition({competition, referrer}: IProps) {
	const {t} = useTranslation();
	const theme = useTheme();
	const [open, setOpen] = useState(false);
	const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
	
	const handleClickOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);
	
	return (
		<div className="w-full">
			<Dialog
				fullScreen={fullScreen}
				open={open}
				onClose={handleClose}
				scroll="paper"
				TransitionComponent={Transition}
				keepMounted
				aria-labelledby="responsive-dialog-title"
				aria-describedby="alert-dialog-slide-description"
			>
				<DialogTitle id="responsive-dialog-title">{t('competitions.conditions')}</DialogTitle>
				<IconButton
					aria-label="close"
					onClick={handleClose}
					sx={{position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500]}}
				>
					<CloseIcon/>
				</IconButton>
				<DialogContent dividers>
					<DialogContentText dangerouslySetInnerHTML={{__html: competition.description as string}}/>
				</DialogContent>
				<DialogActions>
					<Button autoFocus onClick={handleClose}>
						{t('competitions.understood')}
					</Button>
				</DialogActions>
			</Dialog>
			
			<Box
				className="w-full h-[calc(100vh-55px)] overflow-y-scroll justify-center align-middle relative bg-[#004D43]"
				sx={{
					backgroundImage: `url(${bg})`,
					backgroundRepeat: 'no-repeat',
					backgroundSize: 'cover'
				}}
			>
				{/*<div className="flex flex-row w-full justify-center relative z-0">*/}
				{/*	<img src={bg} alt="title"/>*/}
				{/*</div>*/}
				{/*<div className="content flex flex-col h-fit content-around justify-center items-center relative z-50 mt-[30%] gap-y-10 bg-red-400">*/}
				<div
					className="w-full min-h-[calc(100vh-55px)] flex items-center justify-center"
				>
					<div className="w-11/12 m-auto flex flex-col gap-y-10 items-center">
						<div className={'w-11/12'}>
							<img src={barandebash} alt="barandebash"/>
							<img src={line} alt="ramezan"/>
						</div>
						<div className={'w-11/12'}>
							<img src={desc} alt="desc"/>
						</div>
						{/*{isActive && (*/}
							<div className="flex flex-row w-full justify-around">
								<Link to={`/muharram`} className="scaleAnimate">
									<img src={start} alt="start" className={'w-fit h-14'}/>
								</Link>
							</div>
						{/*)}*/}
					</div>
				</div>
			</Box>
		</div>
	);
}
